import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Helper } from '../helper';
import { ModalService } from '../modal-service/modal.service';
import { LabourModel } from './models/labour-model';
import { ProductWarningNotesModel } from './models/product-warnings-notes-model';
import { ProductsNotesModel } from './models/products-notes-model';
import { ProductNotesFormComponent } from './product-notes-form/product-notes-form.component';
import { ProductWarningNotesComponent } from './product-warning-notes/product-warning-notes.component';

@Injectable()
export class ProductNotesService {

	constructor(private modalService: ModalService,
		private translateService: TranslateService) { }

	validateProductWarningsAck(frontWarnings: string[], rearWarnings: string[],
		continueActionResourceKey: string, cancelActionResourceKey: string): Promise<boolean> {
		const warnings = Helper.mergeAndRemoveDuplicateWarnings(frontWarnings, rearWarnings, "FC.Warning.Aggressive.cart:");
		if (warnings && warnings.length > 0) {
			return this.openWarningNoteModal(<ProductWarningNotesModel>{
				warnings: warnings,
				continueActionResourceKey: continueActionResourceKey,
				cancelActionResourceKey: cancelActionResourceKey
			});
		}

		return new Promise((resolve, reject) => {
			resolve(true);
		});
  }

  validateWarnings(messages: string[], index = 0): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      if (index >= messages.length) {
        resolve(true);
      } else {
        this.validateProductWarningsAckNormalPopup([messages[index]], null, '', '').then(ack => {
          if (ack) {
            index += 1;
            this.validateWarnings(messages, index).then(validated => {
              resolve(validated);
            });
          } else {
            resolve(false);
          }
        });
      }
    });
  }

	validateProductWarningsAckNormalPopup(frontWarnings: string[], rearWarnings: string[],
      continueActionResourceKey: string, cancelActionResourceKey: string,
      isAlert: boolean = false, showSkip: boolean = false): Promise<boolean> {
      if (frontWarnings && frontWarnings.length > 0) {
        return this.openWarningNoteModal(<ProductWarningNotesModel>{
          warnings: frontWarnings,
          continueActionResourceKey: continueActionResourceKey,
          cancelActionResourceKey: cancelActionResourceKey,
          showSkip: showSkip,
          isAlert: isAlert,
        });
      }

      return new Promise((resolve, reject) => {
        resolve(true);
      });

	}

	openNoteModal(frontLaboursModel: LabourModel[], rearLaboursModel?: LabourModel[]): Promise<ProductsNotesModel[]> {
		const modalRef = this.modalService.open(ProductNotesFormComponent,
			{
				windowClass: 'fastco-modal',
				backdrop: 'static'
			});

		const model = this.toProductNoteModels(frontLaboursModel, rearLaboursModel);

		(<ProductNotesFormComponent>modalRef.componentInstance).initForm(model);
		return modalRef.result;
	}

	toProductNoteModels(LaboursModel: LabourModel[], rearLaboursModel?: LabourModel[]): ProductsNotesModel[] {
		const productsNoteModel = new Map<string, ProductsNotesModel>();

		LaboursModel.forEach(labourModel => {
			const noteModel = new ProductsNotesModel();
			noteModel.type = labourModel.labour.type;
			noteModel.price = labourModel.labour.details.customerPrice * labourModel.quantity;

			productsNoteModel.set(labourModel.labour.type, noteModel);
		});

		if (rearLaboursModel) {
			rearLaboursModel.forEach(labourModel => {
				let found: ProductsNotesModel;
				if ((found = productsNoteModel.get(labourModel.labour.type))) {
					found.price += labourModel.labour.details.customerPrice * labourModel.quantity;
				} else {
					const noteModel = new ProductsNotesModel();
					noteModel.type = labourModel.labour.type;
					noteModel.price = labourModel.labour.details.customerPrice * labourModel.quantity;

					productsNoteModel.set(labourModel.labour.type, noteModel);
				}
			});
		}

		return Array.from(productsNoteModel.values());
	}

	private openWarningNoteModal(productWarningNotesModel: ProductWarningNotesModel): Promise<any> {
		var modalRef = this.modalService.open(ProductWarningNotesComponent, { windowClass: 'fastco-modal', backdrop: 'static' });
		(<ProductWarningNotesComponent>modalRef.componentInstance).init(productWarningNotesModel);
		return modalRef.result;
	}
}
